export const scopeOfCoverages = [
  "Kasko",
  "Kasko + Lom",
  "Kasko + AO",
  "Imovina",
];
